<template>

  <div>

    <b-row>

      <b-col cols="12" class="ml-0 mr-0">

        <div class="form-inline page-list-search">

          <t-content-header-search-default @searchChange="searchNotExposeQuery()"
                                           @onClearSearch="clearSearch()"
                                           :placeholder="placeholder"
                                           :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                           :search-form="form">

            <t-input v-model="form.statusBulkItemAction" label="Status Processamento do Item" checkbox
                     :options="StatusBulkActionType.list"/>

            <t-input v-model="form.action" label="Ação desejada" checkbox
                     :options="StatusBulkOrderActionType.list"/>


            <t-input-search v-model="form.statusOrder" select :options="StatusProductionOrderType.list"
                            label="Status Ordem de Fabricação"/>

          </t-content-header-search-default>

          <t-input v-if="!onlyView" class="ml-2" style="margin-top:-8px;" :options="listCopyUtilized"
                   @change="copyActionExecute()" v-model="copyAction" select hide-label
                   placeholder="Replicar ação desejada "/>

        </div>

      </b-col>

    </b-row>

    <t-table
        @getPage="getPageNotExposeQuery"
        :show="checkViewListTableDefault()"
        class="mt-2"
        :filtered="filteredDefault || filteredAdvanced"
        :busy="!pageListIsLoaded"
        :items="request.content"
        :fields="onlyView ? fieldsOnlyView : fields"
        :total-pages="request.totalPages"
        :total-elements="request.totalElements"
        title-items="Itens"
        disable-actions-column
        link-primary-column="productionOrderCodeLabel"
        primary-key-column="productionBulkActionItemId">

      <template #first-column="{item}">
        {{ item.productionOrderCodeLabel }}
      </template>

      <template #item(action)="{item}">

        <div v-if="item.statusBulkItemAction === StatusBulkActionType.type.ERROR">

          Erro: {{ item.errorDescription }}

        </div>

        <div v-else>

          <t-input radio
                   hide-label
                   v-model="item.action"
                   class="list_items_bulk_action"
                   :fixed="onlyView"
                   @click="updateBulkItem(item.productionBulkActionItemId)"
                   v-if="StatusProductionOrderType.hasDone(item.statusOrder)"
                   :options="StatusBulkOrderActionType.listFinished"/>

          <div v-else>

            <t-input radio
                     hide-label
                     v-model="item.action"
                     class="list_items_bulk_action"
                     :fixed="onlyView"
                     @click="updateBulkItem(item.productionBulkActionItemId)"
                     :options="listPendingUtilized"/>


            <div style="max-width: 300px" v-if="item.action === StatusBulkOrderActionType.type.FINISH_WITH_ERROR">

              <t-input
                  v-model="item.operationStatusId" required select
                  :fixed="onlyView"
                  @change="updateBulkItem(item.productionBulkActionItemId)"
                  :options="typeStatusProductionOptions" label="Status do Erro"/>

            </div>

            <div style="max-width: 300px" v-if="item.action === StatusBulkOrderActionType.type.SET_OPERATION_STATUS">

              <t-input
                  v-model="item.operationStatusId" required select
                  :fixed="onlyView"
                  @change="updateBulkItem(item.productionBulkActionItemId)"
                  :options="typeStatusProductionCommonOptions" label="Status Operacional"/>

            </div>

            <div style="max-width: 500px" v-else-if="item.action === StatusBulkOrderActionType.type.CHANGE_STEP">

              <t-input v-model="item.processFlowStepId" required select
                       :fixed="onlyView"
                       @change="updateBulkItem(item.productionBulkActionItemId)"
                       :options="stepOptions"
                       label="Etapa"/>


              <t-input v-model="item.typeStopId" required select
                       :fixed="onlyView"
                       @change="updateBulkItem(item.productionBulkActionItemId)"
                       :options="typeProductionOptions"
                       label="Motivo"/>

            </div>


          </div>


        </div>


      </template>


      <template #item(statusOrder)="{item}">
        <ProductionStatusBadge :status="item.statusOrder"
                               v-if="item.statusBulkItemAction !== StatusBulkActionType.type.ERROR"/>

      </template>


      <template #item(delete)="{item}" v-if="!onlyView">
        <b-button
            v-if="userAuth.validation.validationDelete"
            @click="deleteBulkItem(item.productionBulkActionItemId)"
            class="opacity-3-hover"
            size="sm" variant="outline">
          <b-icon icon="trash" variant="danger"></b-icon>
        </b-button>
      </template>

      <template #item(statusBulkItemAction)="{item}">
        <t-bulk-status-badge :status="item.statusBulkItemAction"/>
      </template>


    </t-table>


  </div>


</template>
<style>
.list_items_bulk_action .custom-control.custom-control-inline.custom-radio:last-child {
  color: var(--red) !important;
}

.list_items_bulk_action .bg-fixed-normal {
  background-color: transparent !important;
  border-color: transparent !important;
  font-size: .88rem;
}

</style>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import pageListMixin from "@/mixins/page/pageListMixin";
import StatusBulkActionType from "@/model/types/resource/StatusBulkActionType";
import ProductionStatusBadge from "@/views/modules/production/ProductionOrder/components/ProductionStatusBadge";
import StatusBulkOrderActionType from "@/model/types/modules/production/StatusBulkOrderActionType";
import StatusProductionOrderType from "@/model/types/modules/production/StatusProductionOrderType";
import TypeStatusProductionService from "@/services/modules/production/TypeStatusProduction.service";
import tBulkStatusBadge from "@/components/template/theme/t-bulk-status-badge"
import ui from "@/assets/scripts/ui";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import ProcessFlowStepService from "@/services/modules/production/ProcessFlowStep.service";
import TypeProductionStopService from "@/services/modules/production/TypeProductionStop.service";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageListMixin],
  components: {ProductionStatusBadge, tBulkStatusBadge},
  name: 'ProductKit',
  data() {
    return {
      path: "production/bulk-action-item", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "productionBulkActionId", //Utilizar quando usar Tabs com outros componentes
      StatusBulkOrderActionType,
      StatusBulkActionType,
      StatusProductionOrderType,
      fields: [
        {key: "productionOrderCodeLabel", label: "Ordem Fabricação", cols: "3"},
        {key: "issueDate", label: "Data Emissão", cols: "2", formatter: "date"},
        {key: "statusOrder", label: "Status atual", cols: "5"},
        {key: "action", label: "Ação desejada", cols: "5"},
        {key: "delete", label: "", cols: "1"},
      ],
      fieldsOnlyView: [
        {key: "productionOrderCodeLabel", label: "Ordem Fabricação", cols: "3"},
        {key: "issueDate", label: "Data Emissão", cols: "2", formatter: "date"},
        {key: "action", label: "Ação realizada", cols: "5"},
        {key: "statusBulkItemAction", label: "Status Processamento", cols: "2"},
      ],
      form: {
        productionBulkActionId: this.foreignKey,
        productionBulkActionItemId: 0,
        statusOrder:0,
        action:[],
        statusBulkItemAction: [],
      },
      error: {//Campos que podem receber retorno de erro do backend

      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      headerBulkAction: {},
      listCopyUtilized: [],
      listPendingUtilized: [],
      typeProductionOptions:[],
      stepOptions: [],
      copyAction: 0,
      typeStatusProductionOptions: [],
      typeStatusProductionCommonOptions:[],
      statusOptions: [{value: 1, text: 'Ativos'}, {value: 2, text: 'Inativos'}],
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    foreignNumber: {
      type: Number,
      required: true,
    },
    placeholder: {
      type: String,
      default: ''
    },
    onlyView: Boolean,
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    afterGetPage() {


      for (let item of this.request.content) {

        if (item.statusBulkItemAction === StatusBulkActionType.type.ERROR) {
          item.class = 'alert-danger'
        }

      }

    },

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {
      delete this.form.status
      this.pageFormIsLoaded = false
      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      //Leitura do objeto cabeçalho
      await crudGeneral.getById(this.path.replace('-item', ''), this.foreignNumber).then(async (response) => {
        this.headerBulkAction = response.data
      })

      //Verifica qual a listagem utilizar se for informado um fluxo ou não
      if (this.headerBulkAction.processFlowId > 0) {

        this.listCopyUtilized = StatusBulkOrderActionType.listCopyWithFlow
        this.listPendingUtilized = StatusBulkOrderActionType.listPendingWithFlow

        //Obtem a listagem de etapas de acordo com o fluxo informado
        await ProcessFlowStepService.selectList(this.headerBulkAction.processFlowId)
            .then(list => this.stepOptions = list)
            .catch(error => this.responseError(error))

      } else {
        this.listCopyUtilized = StatusBulkOrderActionType.listCopyNotFlow
        this.listPendingUtilized = StatusBulkOrderActionType.listPendingNotFlow
      }

      await TypeProductionStopService.selectLisTypeReturn()
          .then(list => this.typeProductionOptions = list)
          .catch(error => this.responseError(error))

      this.searchParams.append(this.foreignKeyColumn, this.foreignKey.toString())

      await TypeStatusProductionService.getStatusFinishError()
          .then(list => this.typeStatusProductionOptions = list)
          .catch(error => this.responseError(error))

      await TypeStatusProductionService.getCommon()
          .then(list => this.typeStatusProductionCommonOptions = list)
          .catch(error => this.responseError(error))



      this.pageFormIsLoaded = true

      await this.getPageNotExposeQuery()

    },

    async onSubmit() {

      //Não fazer nada neste caso


    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    async copyActionExecute() {

      if (this.copyAction > 0) {

        const action = this.copyAction

        let option = this.listCopyUtilized.find(a => a.value === this.copyAction)
        let msg = "Tem certeza que deseja selecionar a seguinte ação em massa em todos os registros?<br /><br /><b>" + option.text + "</b>"


        if (this.copyAction === StatusBulkOrderActionType.type.NONE) {
          msg += "<br /><br />Obs.: Esta opção irá limpar as escolhas e deixar todas as ordem com a opção 'Nenhuma' e assim você poderá realizar as escolhas novamente"
        }else if (this.copyAction === StatusBulkOrderActionType.type.REVERSE) {
          msg += "<br /><br />Obs.: Será aplicado somente em Ordens Finalizadas"
        } else if (this.copyAction === StatusBulkOrderActionType.type.FINISH_WITH_SUCCESS) {
          msg += "<br /><br />Obs.: Será aplicado somente em Ordens em andamento"

        }else if(this.copyAction === StatusBulkOrderActionType.type.FINISH_WITH_ERROR){

          msg += "<br /><em>Escolha o status de finalização com erro</em><br />"

          for (const alternative of this.typeStatusProductionOptions) {

            msg += "<div class=\"position-relative form-check\">" +
                "<label class=\"form-check-label\">" +
                "<input name=\"alternativeOperationStatus\" type=\"radio\" value='" + alternative.value + "' class=\"form-check-input\"> " + alternative.text + "   </label>" +
                "</div>"

          }

          msg += "<br /><br />Obs.: Será aplicado somente em Ordens em andamento"

        }else if(this.copyAction === StatusBulkOrderActionType.type.SET_OPERATION_STATUS){

          msg += "<br /><em>Escolha o status operacional</em><br />"

          for (const alternative of this.typeStatusProductionCommonOptions) {

            msg += "<div class=\"position-relative form-check\">" +
                "<label class=\"form-check-label\">" +
                "<input name=\"alternativeOperationStatus\" type=\"radio\" value='" + alternative.value + "' class=\"form-check-input\"> " + alternative.text + "   </label>" +
                "</div>"

          }

          msg += "<br /><br />Obs.: Será aplicado somente em Ordens em andamento"

        } else if (this.copyAction === StatusBulkOrderActionType.type.CHANGE_STEP) {

          for (const alternative of this.stepOptions) {

            msg += "<div class=\"position-relative form-check\">" +
                "<label class=\"form-check-label\">" +
                "<input name=\"alternativeStep\" type=\"radio\" value='" + alternative.value + "' class=\"form-check-input\"> " + alternative.text + "   </label>" +
                "</div>"

          }


          msg += "<br /><b>Motivo</b><br />"

          for (const alternative of this.typeProductionOptions) {

            msg += "<div class=\"position-relative form-check\">" +
                "<label class=\"form-check-label\">" +
                "<input name=\"alternativeTypeStop\" type=\"radio\" value='" + alternative.value + "' class=\"form-check-input\"> " + alternative.text + "   </label>" +
                "</div>"

          }


          msg += "<br /><br />Obs.: Será aplicado somente em Ordens em andamento"


        }

        setTimeout(() => {
          this.copyAction = 0
        }, 100)

        await ui.msgConfirm(this, 'Seleção rápida', msg, async () => {

          if (action === StatusBulkOrderActionType.type.CHANGE_STEP) {

            const processFlowStepId = ui.getAlternativeNativeValue("alternativeStep")
            const typeStopId =  ui.getAlternativeNativeValue("alternativeTypeStop")

            if (processFlowStepId === 0 || typeStopId === 0) {
              ui.msgError(this, 'Para continuar é necessário que você selecione qual a etapa deseja replicar e o motivo da alteração de etapa')
            } else {
              await this.copyActionExecuteContinued(action, 0 , processFlowStepId, typeStopId)
            }

          } else if(action === StatusBulkOrderActionType.type.FINISH_WITH_ERROR || action === StatusBulkOrderActionType.type.SET_OPERATION_STATUS){

            const operationStatusId = ui.getAlternativeNativeValue("alternativeOperationStatus")

            if (operationStatusId === 0) {
              ui.msgError(this, 'Para continuar é necessário que você selecione qual o status operacional deseja replicar')
            } else {
              await this.copyActionExecuteContinued(action, operationStatusId)
            }

          } else {
            await this.copyActionExecuteContinued(action)
          }

        })

      }

    },

    async copyActionExecuteContinued(action, operationStatusId = 0, processFlowStepId = 0, typeStopId = 0) {

      await crudGeneral.get(this.path + "/copyAction/?productionBulkActionId=" + this.foreignKey + "&action=" + action+ "&operationStatusId=" + operationStatusId+ "&processFlowStepId=" + processFlowStepId + "&typeStopId=" + typeStopId).then(() => {

        ui.toast(this, "Informação", "Ações replicadas com sucesso!")
        this.getPageNotExposeQuery(this.pageNumber)

      }).catch(error => this.responseError(error))

    },

    async updateBulkItem(id) {

      if (!this.onlyView) {

        let obj = this.request.content.find(a => a.productionBulkActionItemId === id)

        if (obj !== null) {

          let operationStatusId = 0
          let processFlowStepId = 0
          let typeStopId = 0

          if (obj.action === StatusBulkOrderActionType.type.FINISH_WITH_ERROR) {

            operationStatusId = obj.operationStatusId

            if (operationStatusId === 0 || operationStatusId === undefined) {
              //Seleciona a primera opção por padrão dos status com erro
              operationStatusId = this.typeStatusProductionOptions[0].value
              obj.operationStatusId = operationStatusId
            }

          }else if (obj.action === StatusBulkOrderActionType.type.SET_OPERATION_STATUS) {

              operationStatusId = obj.operationStatusId

              if (operationStatusId === 0 || operationStatusId === undefined) {
                //Seleciona a primera opção por padrão dos status com erro
                operationStatusId = this.typeStatusProductionCommonOptions[0].value
                obj.operationStatusId = operationStatusId
              }

          }else if(obj.action === StatusBulkOrderActionType.type.CHANGE_STEP){

            processFlowStepId = obj.processFlowStepId
            typeStopId = obj.typeStopId

            if (processFlowStepId === 0 || processFlowStepId === undefined) {
              //Seleciona a primera opção por padrão das etapas do fluxo
              processFlowStepId = this.stepOptions[0].value
              obj.processFlowStepId = processFlowStepId
            }

            if (typeStopId === 0 || typeStopId === undefined) {
              //Seleciona a primera opção por padrão dos tipos de retorno motivo
              typeStopId = this.typeProductionOptions[0].value
              obj.typeStopId = typeStopId
            }

          }

          const update = {
            productionBulkActionId: this.foreignKey,
            productionBulkActionItemId: id,
            action: obj.action,
            statusBulkItemAction: StatusBulkActionType.type.PENDING,
            operationStatusId,
            processFlowStepId,
            typeStopId,
            status: 1,

          }

          await crudGeneral.update(this.path, update).then(() => {


          }).catch(error => alert(error))

        }

      }


    },

    async deleteBulkItem(id) {

      if (!this.onlyView) {

        ui.msgConfirmDelete(this, async () => {

          await crudGeneral.remove(this.path, id).then(() => {

            ui.toast(this, "Informação", "Exclusão do item da ação em massa realizada com sucesso!")
            this.getPageNotExposeQuery(this.pageNumber)

          }).catch(error => alert(error))
        }, 'Tem certeza que deseja remover este item desta ação em massa?')

      }


    }

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
